<template>
  <div class="box">
    <div
      class="box-content"
      @mouseenter="swiper_enter"
      @mouseleave="swiper_leave"
    >
      <div class="swiper-button-prev swiper-button-prev2"></div>
      <swiper ref="swiper" :options="options">
        <swiper-slide v-for="(item, index) in imgeList" :key="index">
          <div class="card">
            <img :src="require('@/assets/imglist/' + item)" alt="" />
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next swiper-button-next2"></div>
    </div>
  </div>
</template>
 
<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: { Swiper, SwiperSlide },
  data() {
    return {
      imgeList: [],
      options: {
        pagination: {
          el: ".case-swiper-pagination",
          //区分不同Swiper的组件
        },
        //显示分页
        loop: true,
        //开启循环
        loopedSlides: 6,
        //设置平滑
        slidesPerView: 4,
        //设置能够同时显示的数量（可设置 auto）
        speed: 1000,
        //切换速度

        navigation: {
          prevEl: ".swiper-button-prev2",
          nextEl: ".swiper-button-next2",
        },
        //左右箭头按钮(可自定义)

        // autoplay: false,
        //是否开启自动轮播

        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 开启自动轮播后，设置自动轮播的延迟时间
        loopAdditionalSlides: 1,
        //复制若干个slide
        // slidesPerGroup: 3,
        // 定义slides的数量多少为一组，即每次切换slides的数量，默认每次切换一张
        on: {
          slideChangeTransitionEnd: function () {
            // console.log(this.activeIndex);
            //获取当前下标，切换结束时，告诉我现在是第几个slide
          },
        },
      },
    };
  },
  /* 引入组件 */
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    },
    imgList() {
      return this.$t("imgList");
    },
  },
  created() {
    this.imgeList = this.imgList;
  },
  methods: {
    swiper_enter() {
      this.swiper.autoplay.stop();
    },
    //鼠标悬停停止swiper自动轮播
    swiper_leave() {
      this.swiper.autoplay.start();
    },
    //鼠标移出开启swiper自动轮播
  },
};
</script>
 
<style lang="less" scoped>
.box {
  width: 100%;
  background-color: #fff;
}

.box-content {
  width: 1280px;
  margin: 0 auto;
  position: relative;

  .swiper-slide {
    margin: 30px 0;
    margin-right: 10px;
    border-radius: 10px;

    .card {
      width: 320px;
      height: 260px;
      //   background: url("https://img2.baidu.com/it/u=1473738496,3480051138&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500")
      //     no-repeat;
      //   background-size: 340px 320px;
      position: relative;
      border-radius: 10px;

      img {
        width: 320px;
        height: 260px;
        border-radius: 10px;
      }

      cursor: pointer;
    }
  }
}
@media screen and (max-width: 1080px) {
  .box-content {
    width: 108rem;
    margin: 0 auto;
    position: relative;

    .swiper-slide {
      width: 78rem !important;
      margin: 5rem 0;
      margin-right: 1rem;
      border-radius: 2rem;

      .card {
        width: 78rem;
        height: 65rem;
        //   background: url("https://img2.baidu.com/it/u=1473738496,3480051138&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500")
        //     no-repeat;
        //   background-size: 340px 320px;
        position: relative;
        border-radius: 2rem;

        img {
          width: 78rem;
          height: 65rem;
          border-radius: 2rem;
        }

        cursor: pointer;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  }
}
</style>